/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminSchedulingLinkId,
  BulkUpdateUserLicensesRequestByFilterV2,
  BulkUpdateUserRolesRequestByFilterV2,
  BulkWorkspaceReassignmentRequestByFilterV2,
  CheckLicenseUpdateResponse,
  MapString,
  PaginatedResultUMTUser,
  PaginatedResultUserAggregate,
  UpdateExtensionDownloadStatusRequest,
  UserQueryFilterV2,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V2<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "workspace";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Deprecated - use bulk update users assigned workspaces v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name UpdateWorkspacesAssignedByFilterV2
   * @request POST:/v2/tenant/{tenantId}/users/workspaces/by-filter
   * @deprecated
   * @secure
   */
  updateWorkspacesAssignedByFilterV2 = (
    tenantId: string,
    data: BulkWorkspaceReassignmentRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/workspaces/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateWorkspacesAssignedByFilterV2 */
  updateWorkspacesAssignedByFilterV2PathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/users/workspaces/by-filter`);

  /**
   * @description Deprecated - use find users by filter v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name QueryUsers
   * @request POST:/v2/tenant/{tenantId}/users
   * @deprecated
   * @secure
   */
  queryUsers = (
    tenantId: string,
    data: UserQueryFilterV2,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUserAggregate,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for queryUsers */
  queryUsersPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/users`, query);

  /**
   * @description Deprecated - use remove users by filter v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name RemoveUsersByFilter
   * @request DELETE:/v2/tenant/{tenantId}/users/by-filter
   * @deprecated
   * @secure
   */
  removeUsersByFilter = (tenantId: string, data: UserQueryFilterV2, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/by-filter`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for removeUsersByFilter */
  removeUsersByFilterPathGetter = (tenantId: string) => this.getServicePath(`/v2/tenant/${tenantId}/users/by-filter`);

  /**
   * @description Deprecated - use bulk update users by filter roles v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name UpdateUserRolesByFilter
   * @request POST:/v2/tenant/{tenantId}/users/roles/by-filter
   * @deprecated
   * @secure
   */
  updateUserRolesByFilter = (
    tenantId: string,
    data: BulkUpdateUserRolesRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/roles/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserRolesByFilter */
  updateUserRolesByFilterPathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/users/roles/by-filter`);

  /**
   * @description Deprecated - use bulk update users by filter licenses v3
   *
   * @tags Admin User Table, User Management Table, UMT, license
   * @name UpdateUserLicensesByFilter
   * @request POST:/v2/tenant/{tenantId}/users/licenses/by-filter
   * @deprecated
   * @secure
   */
  updateUserLicensesByFilter = (
    tenantId: string,
    data: BulkUpdateUserLicensesRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/licenses/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserLicensesByFilter */
  updateUserLicensesByFilterPathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/users/licenses/by-filter`);

  /**
   * @description Deprecated - use check if bulk update users by filter licenses v3 is possible
   *
   * @tags Admin User Table, User Management Table, UMT, license
   * @name CheckUpdateUserLicensesByFilter
   * @request POST:/v2/tenant/{tenantId}/users/licenses/by-filter/check
   * @deprecated
   * @secure
   */
  checkUpdateUserLicensesByFilter = (
    tenantId: string,
    data: BulkUpdateUserLicensesRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      CheckLicenseUpdateResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/licenses/by-filter/check`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for checkUpdateUserLicensesByFilter */
  checkUpdateUserLicensesByFilterPathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/users/licenses/by-filter/check`);

  /**
   * @description Deprecated - use update user extension download status v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name UpdateExtensionDownloadStatus
   * @request POST:/v2/tenant/{tenantId}/user/{userId}/extension-download-status
   * @deprecated
   * @secure
   */
  updateExtensionDownloadStatus = (
    tenantId: string,
    userId: string,
    data: UpdateExtensionDownloadStatusRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/user/${userId}/extension-download-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateExtensionDownloadStatus */
  updateExtensionDownloadStatusPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/user/${userId}/extension-download-status`);

  /**
   * @description Deprecated - use export users as csv v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name ExportUsersAsCsv
   * @request POST:/v2/tenant/{tenantId}/users/csv
   * @deprecated
   * @secure
   */
  exportUsersAsCsv = (
    tenantId: string,
    data: UserQueryFilterV2,
    query?: {
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/csv`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for exportUsersAsCsv */
  exportUsersAsCsvPathGetter = (
    tenantId: string,
    query?: {
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/users/csv`, query);

  /**
   * @description Deprecated - use v3
   *
   * @tags Admin User Table, User Management Table, UMT
   * @name FindUserManagementTableUsers
   * @request POST:/v2/tenant/{tenantId}/user-management-table/users/by-filter
   * @deprecated
   * @secure
   */
  findUserManagementTableUsers = (
    tenantId: string,
    data: UserQueryFilterV2,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUMTUser,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/user-management-table/users/by-filter`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUserManagementTableUsers */
  findUserManagementTableUsersPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/user-management-table/users/by-filter`, query);
}
